<script>
import _ from 'lodash';

export default {
  props: {
    state: { required: true, type: Object }
  },

  data() {
    return {
      stateData: this.state,
      observer: null
    };
  },

  mounted() {
    this.initScrollObserver();
    window.addEventListener('scroll', this.handleScroll);
  },

  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    set(property, value) {
      this.debouncedSet =
        this.debouncedSet ||
        _.debounce((property, value) => {
          this.$set(this.stateData, property, value);
        }, 100);
      this.debouncedSet(property, value);
    },

    initScrollObserver() {
      const options = {
        root: null,
        rootMargin: '0px 0px -80% 0px',
        threshold: 0
      };

      this.observer = new IntersectionObserver(this.onIntersect, options);
      const sections = document.querySelectorAll('.resource-content [id]');

      sections.forEach((section) => {
        this.observer.observe(section);
      });
    },

    onIntersect(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.set('path', entry.target.id);
        }
      });
    },

    handleScroll() {
      const scrollPosition = window.innerHeight + window.scrollY;
      const documentHeight = document.body.offsetHeight;
      const bottomThreshold = 50;

      if (scrollPosition >= documentHeight - bottomThreshold) {
        const lastSection = document.querySelector('.resource-content [id]:last-child');
      }
    }
  },

  render() {
    return this.$scopedSlots.default({
      state: this.stateData,
      setState: this.set
    });
  }
};
</script>
